/* eslint-disable no-unused-expressions */

import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Row, Table } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import LeaveFilter from "../../../components/LeaveFilter";
import { useLocation, useNavigate } from "react-router-dom";


const CallToActionReport = () => {

  const location = useLocation();
  const consumerListData = location.state.consumerList
  const [fieldInputs, setFieldInputs] = useState(true);
  const [reqState, setReqState] = useState();
  const [isFullScreen, setFullScreen] = useState(false);
  const maximizeBtnRef = useRef(null);
  const navigate = useNavigate();

  const tableData = [];

  // useEffect(() => {
  //   const handleClick = () => {
  //     if (!document.fullscreenElement) {
  //       document.documentElement.requestFullscreen();
  //       setFullScreen(true);
  //     } else {
  //       if (document.exitFullscreen) {
  //         document.exitFullscreen();
  //         setFullScreen(false);
  //       }
  //     }
  //   };

  //   const cleanup = () => {
  //     if (isFullScreen && document.exitFullscreen) {
  //       document.exitFullscreen();
  //       setFullScreen(false);
  //     }
  //   };

  //   //console.log("reqStatereqStatereqState", reqState);

  //   // Cleanup function to remove the event listener and exit fullscreen on component unmount
  //   return () => {
  //     maximizeBtn.removeEventListener("click", handleClick);
  //     cleanup();
  //   };
  // }, [isFullScreen]);

  // const token = localStorage.getItem("LogIn_Token");


  const columns = [
    {
      title: "Account Id",
      dataIndex: "AC_ID",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.AC_ID.length - b.AC_ID.length,
    },

    {
      title: "Name",
      dataIndex: "NAME",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.NAME.length - b.NAME.length,
    },

    {
      title: "Net Bill",
      dataIndex: "NET_BILL",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.NET_BILL.length - b.NET_BILL.length,
    },
    {
      title: "Reminder Date",
      render: () => {
        const currentDate = new Date().toLocaleDateString(); // Get the current date
        return <span>{currentDate}</span>; // Display the current date for each row
      },
    },
  ];

  const renderPlaceholder = () => (
    <>
      <p className="placeholder-glow">
        <span className="placeholder col-12" />
      </p>
      <p className="placeholder-wave mb-0">
        <span className="placeholder col-12" />
      </p>
    </>
  );

  // const placeholderData = new Array(5).fill({});
  return (
    <>
      {/* <submitToast/> */}
      <ToastContainer />
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Call To Action Report</h3>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                </div>
              </div>
            </div>
          </div>
          {/* Page Header */}
          <hr />

         
          {/* /Leave Statistics */}
          <button className="btn-outline-dark" onClick={() => (navigate("/call-to-action"))}>Exit From Report</button>
          <br></br>
          <br></br>

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                {
                  <Table
                    rowKey={(record) => record.id}
                    scroll={{ y: 300 }}
                    columns={ columns}
                    dataSource={
                      consumerListData?.length > 0
                        ? consumerListData
                        : []
                    }
                    
                    className="table-striped"
                  />
                }
              </div>
            </div>
          </div>
        </div>

        
      </div>
    </>
  );
};

export default CallToActionReport;
